let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8wD2e")).then(() => parcelRequire('diZSV'));